import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Auth state. Persisted to localStorage so a page reload keeps the session.
 * Per Tech Impl § 8.2 the access token lives here and is attached to every
 * outgoing request by the axios interceptor; the refresh token lives in the
 * HttpOnly cookie set by the backend, never in JS.
 */
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      accessToken: null,

      setSession: (user, accessToken) => set({ user, accessToken }),
      setUser: (user) => set({ user }),
      setAccessToken: (accessToken) => set({ accessToken }),
      clear: () => set({ user: null, accessToken: null }),
    }),
    {
      name: "sher-e-punjab-admin-auth",
      // Only persist what's reload-survivable. Token will be re-validated by
      // the next API call; if the refresh-cookie is also expired the
      // interceptor will redirect to /login.
      partialize: (s) => ({ user: s.user, accessToken: s.accessToken }),
    }
  )
);

// Convenience selectors so components don't have to call useAuthStore directly.
export const selectUser = (s) => s.user;
export const selectAccessToken = (s) => s.accessToken;
export const selectIsAuthed = (s) => Boolean(s.user && s.accessToken);
export const selectIsSuperAdmin = (s) => s.user?.role === "super_admin";
